// extracted by mini-css-extract-plugin
export default {"products":"Products_products__iaaKH","media":"Products_media__6+aKw","video":"Products_video__Tl+En"};